const topics = [
  { name: '明星恋情曝光', heat: '980万', posts: '12.6万', trend: 'hot' },
  { name: '综艺节目争议', heat: '860万', posts: '10.2万', trend: 'hot' },
  { name: '网红直播翻车', heat: '750万', posts: '9.3万', trend: 'hot' },
  { name: '热播剧大结局', heat: '690万', posts: '8.7万', trend: 'rising' },
  { name: '音乐节阵容', heat: '580万', posts: '7.1万', trend: 'rising' },
  { name: '明星私服穿搭', heat: '520万', posts: '6.4万', trend: 'rising' },
  { name: '影视新作定档', heat: '460万', posts: '5.8万', trend: 'normal' },
  { name: '社交媒体热议', heat: '410万', posts: '5.2万', trend: 'normal' },
  { name: '娱乐产业趋势', heat: '350万', posts: '4.5万', trend: 'normal' },
];

export default function TopicsSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">热门话题</h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
              探索当前最受关注的吃瓜话题，点击标签深入浏览相关资讯
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {topics.map((topic, idx) => (
              <a
                key={idx}
                href="#topics"
                onClick={(e) => handleNavClick(e, '#topics')}
                className="group flex items-center gap-4 p-4 md:p-5 bg-background-100 rounded-lg hover:bg-background-200/70 transition-colors cursor-pointer"
              >
                <div className={`w-11 h-11 flex items-center justify-center rounded-lg flex-shrink-0 ${
                  topic.trend === 'hot'
                    ? 'bg-primary-100 text-primary-600'
                    : topic.trend === 'rising'
                    ? 'bg-accent-100 text-accent-700'
                    : 'bg-secondary-100 text-secondary-600'
                }`}>
                  <i className={`text-lg ${
                    topic.trend === 'hot' ? 'ri-fire-line' : topic.trend === 'rising' ? 'ri-arrow-up-line' : 'ri-hashtag'
                  }`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm md:text-base text-foreground-800 font-medium group-hover:text-primary-600 transition-colors truncate">
                      #{topic.name}
                    </span>
                    {topic.trend === 'hot' && (
                      <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-500 text-background-50 flex-shrink-0">热</span>
                    )}
                    {topic.trend === 'rising' && (
                      <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-500 text-background-50 flex-shrink-0">升</span>
                    )}
                  </div>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span>{topic.heat} 热度</span>
                    <span>{topic.posts} 讨论</span>
                  </div>
                </div>
                <i className="ri-arrow-right-s-line text-lg text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}